export enum EntitlementEnum {
  'premium' = 'premium', // any text
  '*' = 'freemium',
  '?' = 'free'
}

export enum ViewPermission {
  Freemium = 'Freemium',
  Premium = 'Premium',
  Free = 'Free'
}

export interface ViewPermissionResponse {
  locked: boolean;
  permission: ViewPermission;
}
